var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconErrorCrossFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#BF1D26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7373 12.0802C21.9155 11.8989 21.9155 11.6083 21.7373 11.427L20.6085 10.2781C20.4259 10.0922 20.1263 10.0922 19.9437 10.2781L16.2594 14.0279C16.0768 14.2138 15.7772 14.2138 15.5946 14.0279L12.0561 10.4266C11.8735 10.2407 11.5739 10.2407 11.3913 10.4266L10.2625 11.5754C10.0844 11.7568 10.0844 12.0474 10.2625 12.2287L13.824 15.8535C14.0021 16.0348 14.0021 16.3254 13.824 16.5067L10.6202 19.7674C10.442 19.9488 10.442 20.2394 10.6202 20.4207L11.749 21.5695C11.9316 21.7554 12.2312 21.7554 12.4138 21.5695L15.5946 18.3322C15.7772 18.1463 16.0768 18.1463 16.2594 18.3322L19.586 21.718C19.7687 21.9039 20.0682 21.9039 20.2509 21.718L21.3797 20.5692C21.5578 20.3878 21.5578 20.0972 21.3797 19.9159L18.03 16.5067C17.8519 16.3254 17.8519 16.0348 18.03 15.8535L21.7373 12.0802Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorCrossFilled);
export default __webpack_public_path__ + "static/media/icon-error-cross-filled.623a67e483c9eb6c238032f21ec8ae1b.svg";
export { ForwardRef as ReactComponent };